import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { TextBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { color } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/color";
import { fontFamily } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontFamily";
import { fontSize } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontSize";
import { fontStyle } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontStyle";
import { fontWeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontWeight";
import { lineHeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/lineHeight";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { textAlign } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textAlign";
import { textDecoration } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textDecoration";
import { textTransform } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textTransform";
import {
  ContentProp,
  DesignProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Paragraph",
  nameI18n: "builder_ui.block_type.p",
  version: 1,
  category: [TextBlock],
  props: {
    text: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      category: [ContentProp],
      prop: "other",
      type: "rich-text",
    },
    paragraphStyle: {
      name: "Paragraph style",
      nameI18n: "builder_ui.prop_type.paragraph_style",
      category: [ContentProp],
      prop: "other",
      type: "paragraph-style-picker",
      defaultValue: "p1",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        color: {
          ...color,
          defaultValue: defaultStyles.color,
        },
        textTransform: {
          ...textTransform,
          defaultValue: defaultStyles.textTransform,
        },
        fontStyle: {
          ...fontStyle,
          defaultValue: defaultStyles.fontStyle,
        },
        fontFamily: {
          ...fontFamily,
          defaultValue: defaultStyles.fontFamily,
        },
        fontWeight: {
          ...fontWeight,
          defaultValue: defaultStyles.fontWeight,
        },
        fontSize: {
          ...fontSize,
          defaultValue: defaultStyles.fontSize,
        },
        lineHeight: {
          ...lineHeight,
          defaultValue: defaultStyles.lineHeight,
        },
        textAlign: {
          ...textAlign,
          defaultValue: defaultStyles.textAlign,
        },
        textDecoration: {
          ...textDecoration,
          defaultValue: defaultStyles.textDecoration,
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
      },
    },
  },
};
